import styled from "styled-components";
import { units } from "@m/alchemy-theme";
import { Input } from "../input/Input";
import { StyledCalendarButton } from "../date-picker/CalendarButton";
export const DateInput = styled(Input) `
  ${StyledCalendarButton} {
    position: absolute;
    right: ${units(1.75)};
    top: ${units(1)};
  }

  input {
    min-width: 100px;
    padding-right: ${units(4)};
  }
`;
